var service = function(C) {
  // Given an object, such as a Retailer or Distributor,
  // return a single string representing their address.
  var addressString = function(obj) {
    var str = '';

    _.each(['address1', 'address2', 'address3'], function(prop) {
      if (obj[prop]) {
        if (str) str += ' ';
        str += obj[prop].trim();
      }
    });

    _.each(['city', 'state'], function(prop) {
      if (obj[prop]) {
        if (str) str += ', ';
        str += obj[prop].trim();
      }
    });

    if (obj.zip) {
      if (str) str += ' ';
      str += obj.zip.trim();
    }

    return str;
  };

  var stateString = function(stateAbbr) {
    var state = _.find(C.states, { abbreviation: stateAbbr });
    return (state ? state.name : stateAbbr);
  };

  return {
    addressString: addressString,
    stateString: stateString
  };

};

service.$inject = ['C'];

tiz.service('CommonHelpers', service);
